<template>
  <b-overlay :show="isUpload" rounded="sm">
    <div>
      <!-- header  -->
      <section :class="userData.isAndroid
          ? 'padding-nevigate-bar-ANDROID'
          : 'padding-nevigate-bar-IOS'
        " v-if="userData.channel != 'WEB'">
        <div class="row no-gutters">
          <div class="col-2 pl-2 justify-content-center align-self-center">
            <div @click="goToPreviousPage()">
              <b-icon class="text-kanit-color-black" icon="chevron-left" style="width: 24px; height: 24px" />
            </div>
          </div>
          <div class="col-8 justify-content-center align-self-center">
            <div class="mx-0 text-center font-kanit-bold-20">
              {{ this.currentMenu.pageName }}
            </div>
          </div>
          <div class="col-2 px-0"></div>
        </div>
      </section>

      <div class="justify-content-md-center p-3 d-flex flex-column justify-content-between h-100"
        :style="userData.isAndroid ? '' : 'overflow-y: scroll;'" style="height: 95vh !important;">
        <div>
          <b-row class="mt-3">
            <b-col>
              <span class="font-kanit-bold-16 text-kanit-color-black"><span>Statement จากบัญชีกรุงไทย</span></span>
            </b-col>
          </b-row>
          <b-row class="">
            <b-col>
              <span class="font-kanit-regular-16 text-kanit-color-grey"><span>สามารถเลือกได้มากกว่า 1
                  บัญชี</span></span>
            </b-col>
          </b-row>
          <div v-if="lstAccount.length > 0" class="my-4">
            <b-card v-for="item in lstAccount" :key="item.accountNo" :class="'border-radius-1rem ' +
              (isCardActive(item)
                ? 'card-active'
                : '' +
                ' ' +
                (checkEnable(item) ? 'card-disabled' : 'card-enabled'))
              " style="margin-top: 8pt" :body-class="'p-3 ' + (checkEnable(item) ? 'cantClick' : 'canClick')
                " @click="onSelected(item)">
              <b-row>
                <b-col cols="2" align-self="center">
                  <!-- style="padding: 0px !important;" -->
                  <b-img center height="48" width="48" :src="!checkEnable(item)
                      ? icon_ktb_bookbank
                      : icon_ktb_bookbank_disable
                    "></b-img>
                </b-col>
                <b-col cols="8" align-self="center">
                  <b-row class="pl-2">
                    <b-col class="pl-3 content-nowrap" :class="checkEnable(item)
                        ? 'font-kanit-bold-16 text-kanit-color-disables'
                        : 'font-kanit-bold-16 text-kanit-color-black'
                      " align-self="center">
                      {{ item.accountName }}</b-col>
                    <div class="w-100" />
                    <b-col :class="checkEnable(item)
                        ? 'font-kanit-regular-14 text-kanit-color-disables'
                        : 'font-kanit-regular-14 text-kanit-color-grey'
                      " align-self="center">
                      {{ covertAccountType(item.productGrp) }}
                      {{ patternAccount(item.accountNo) }}</b-col>
                    <div class="w-100" />
                    <template v-if="checkEnable(item)">
                      <div class="w-100" />
                      <b-col class="font-kanit-regular-14 text-kanit-color-danger" style="line-height: 24px"
                        align-self="center">
                        {{ item.errorMsg }}</b-col>
                    </template>
                  </b-row>
                </b-col>
                <b-col cols="2" align-self="center">
                  <div class="custom-control custom-checkbox">
                    <input :value="item.accountNo" v-model="accountSelected" :disabled="checkEnable(item)"
                      type="checkbox" class="custom-control-input" :id="'customCheck' + item.accountNo" />
                    <label class="custom-control-label" for="customCheck1"></label>
                  </div>
                </b-col>
              </b-row>
            </b-card>

            <div class="w-100 border-top-NEXT my-4" />
            <b-row class="my-3">
              <b-col>
                <b-card class="paleGrey">
                  <b-card-text>
                    <b-row style="line-height: 24px" class="mb-2">
                      <b-col class="px-3 font-kanit-regular-16 text-kanit-color-grey"><span
                          style="vertical-align: bottom">รายการเดินบัญชีระหว่างวันที่</span></b-col>
                    </b-row>
                    <b-row style="line-height: 24px">
                      <b-col class="px-3 font-kanit-bold-18 text-kanit-color-black"><span
                          style="vertical-align: bottom">{{
                            periodStatementKtb
                          }}</span></b-col>
                    </b-row>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </div>
        <div v-if="lstAccount.length > 0">
          <b-row v-if="!accountDisableAll">
            <b-col align-self="center">
              <button v-if="!checkDocIsSuccess()" @click="onSubmit()" :disabled="accountSelected === undefined || accountSelected.length == 0
                " class="btn btn-block btn-submit-landing-page">
                {{ "เลือกบัญชี" }}
              </button>
              <!-- <button
              v-else
              @click="onCancelStatement()"
              :disabled="
                userData.accountSelected !== undefined &&
                userData.accountSelected.length > 0
              "
              class="btn btn-block btn-submit-landing-page btn-cancel-dstatement"
            >
              {{ "ยกเลิก statement" }}
            </button> -->
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col align-self="center">
              <button disabled @click="goback()" class="btn btn-block btn-submit-landing-page">
                {{ "เลือกบัญชี" }}
              </button>
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- modal back-->

      <b-modal v-model="modalShowBackStep" hide-header hide-header-close hide-footer
        content-class="content-dialog-back">
        <div class="justify-content-center py-4">
          <b-row>
            <b-col style="text-align: center"><span
                class="font-kanit-bold-20 text-kanit-color-black">ยืนยันการออกจากหน้านี้?</span></b-col>
          </b-row>
          <b-row class="pt-2">
            <b-col style="text-align: center">
              <span class="font-kanit-regular-16 text-kanit-color-black">ข้อมูลของคุณจะไม่ถูกบันทึก</span></b-col>
          </b-row>

          <b-row class="pt-4">
            <b-col cols="6">
              <b-button class="btn-block btn btn-info btn-ktb-cancel btn-cancel-file-duplication"
                @click="modalShowBackStep = !modalShowBackStep">
                <span class="">ยกเลิก</span>
              </b-button>
            </b-col>

            <b-col cols="6">
              <b-button class="btn-block btn btn-info btn-confirm-file-duplication" @click="clearData()">
                <span class="">ออกจากหน้านี้</span>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>
    </div>
  </b-overlay>
</template>
<script>
import axios from "axios";
export default {
  computed: {
    userData() {
      return this.$store.state.userData;
    },
  },
  async created() {
    try {
      this.$callback.enterFullScreen();
    } catch (err) {
      //console.error(err);
    }
    const fnSet = this.setIsLoading;
    const timeoutAxios = this.timeout;
    this.axiosInstance = axios.create({
      baseURL: this.urlapi,
      headers: { Authorization: this.userData.token },
    });
    this.axiosInstance.interceptors.request.use(
      function (config) {
        config.timeout = timeoutAxios;
        fnSet(true);
        return config;
      },
      function (error) {
        fnSet(false);
        // Do something with request error
        return Promise.reject(error);
      }
    );
    this.axiosInstance.interceptors.response.use(
      function (response) {
        fnSet(false);
        return response;
      },
      function (error) {
        fnSet(false);
        return Promise.reject(error);
      }
    );

    this.currentMenu = {
      pageCode: "CommonListAccount",
      pageName: this.userData.document_group_type.find(
        (i) => i.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      ).grp_name,
      previousPage: this.userData.routerPath.documentGroup,
      params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
      isShow: true,
    };
    this.$event.$emit("update_current_menu", this.currentMenu);
    if (this.userData.listAccount != undefined) {
      this.lstAccount = this.userData.listAccount;
      this.accountDisableAll =
        this.lstAccount.length ==
        this.lstAccount.filter(
          (i) => i.errorMsg != "" && i.errorMsg != undefined
        ).length;
    } else {
      await this.getAccountCBS();
    }
    if (
      this.userData.accountSelected != undefined &&
      this.userData.accountSelected.length != 0
    ) {
      this.accountSelected = this.userData.accountSelected;
    }

    if (this.$route.params.checkDocIsSuccess != undefined) {
      this.checkStateSuccess = this.$route.params.checkDocIsSuccess;
    }
    this.periodStatementKtb = this.userData.periodStatementKtb;
    this.lstDescription = [];
    try {
      if (
        ("1083" == this.userData.marketCode &&
          "2011" == this.userData.productType) ||
        ("1099" == this.userData.marketCode &&
          "7002" == this.userData.productType)
      ) {
        let document_group_type = this.userData.document_group_type.find(
          (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
        );
        let docCode = document_group_type.lst_doc_id[0];
        const docType = this.userData.documentType.find(
          (item) => item.doc_code == docCode
        );
        this.lstDescription.push(docType.doc_short_name);
      } else {
        this.lstDescription.push(
          "มีข้อมูลย้อนหลัง " + this.userData.monthCalc + " เดือน"
        );
      }
    } catch (err) {
      this.lstDescription.push("มีข้อมูลย้อนหลัง 6 เดือน");
    }
    this.scaleUpCheckbox();
    window.onMobileBackPressed = function () {
      // console.log("onMobileBackPressed");
      this.goToPreviousPage();
      return true;
    };

  },
  data() {
    return {
      timeout: parseInt(process.env.VUE_APP_TIMEOUT),
      checkStateSuccess: false,
      imgNEXT: require("@/assets/images/BankLogo/KTB.png"),
      icon_ktb_bookbank: require("@/assets/images/BankLogo/KTB.png"),
      icon_ktb_bookbank_disable: require("@/assets/images/ic_bank_ktb_disables.png"),
      lstDescription: [],
      accountSelected: [],
      lstAccount: [],
      objAcc: null,
      urlapi: process.env.VUE_APP_APIURL,
      axiosInstance: null,
      periodStatementKtb: "",
      isUpload: false,
      accountDisableAll: false,
      imgSwalErr: require("@/assets/images/ic_swal_error_reject.png"),
      currentMenu: null,
      modalShowBackStep: false,
    };
  },
  methods: {
    goToPreviousPage() {
      const docType = this.userData.documentType.find(
        (v) => v.doc_code == this.getDocCode()
      );
      if (docType.state == "success") {
        this.goback();
        return;
      }
      // console.log(this.userData.accountSelected);
      // console.log(this.accountSelected);
      if (this.accountSelected.length == 0) {
        this.goback();
      } else {
        this.modalShowBackStep = true;
      }
    },
    getDocCode() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      return document_group_type.lst_doc_id[0];
    },
    clearData() {
      this.userData.accountSelected = [];
      this.goback();
    },
    scaleUpCheckbox() {
      document.styleSheets[0].addRule(
        "custom-control-label:before",
        "width: 24px"
      );
    },
    setIsLoading(value) {
      this.isUpload = value;
    },
    goToListAccount() {
      this.$router.push({
        name: this.userData.routerPath.listAccount,
      });
    },
    covertAccountType(productGrp) {
      switch (productGrp) {
        case "SAV":
          return "ออมทรัพย์";
        default:
          return "กระแสรายวัน";
        // default:
        //   return "not found";
      }
    },
    checkEnable(item) {
      return item.errorMsg != undefined && item.errorMsg != "";
    },
    isCardActive(item) {
      return this.accountSelected.includes(item.accountNo);
    },
    onSelected(item) {
      if (this.checkEnable(item)) return;
      if (this.isCardActive(item)) {
        const index = this.accountSelected.indexOf(item.accountNo);
        if (index > -1) {
          this.accountSelected.splice(index, 1);
        }
      } else {
        this.accountSelected.push(item.accountNo);
      }
    },
    onSubmit() {
      if (this.lstAccount.length == 1 && this.accountSelected.length == 0)
        this.onSelected(this.lstAccount[0]);
      this.userData.listAccount = this.lstAccount;
      this.userData.accountSelected = this.accountSelected;
      this.$store.dispatch("setUserData", this.userData);
      this.$router.push({
        name: this.userData.routerPath.documentGroup,
        params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
      });
    },
    onCancelStatement() {
      this.accountSelected = [];
      this.userData.listAccount = this.lstAccount;
      this.userData.accountSelected = [];
      this.$store.dispatch("setUserData", this.userData);
      this.$router.push({
        name: this.userData.routerPath.documentGroup,
        params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
      });
    },
    async getAccountCBS() {
      let grp01 = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docIdStatement;
      if (grp01 !== undefined) {
        docIdStatement = grp01.lst_doc_id[0];
      }

      //  let response =
      this.axiosInstance({
        method: "GET",
        url: "api/accountInfo?docIdStatement=" + docIdStatement,
      })
        .then((response) => {
          this.userData.listAccount = response.data;
          this.$store.dispatch("setUserData", this.userData);
          this.lstAccount = this.userData.listAccount;
          this.accountDisableAll =
            this.lstAccount.length ==
            this.lstAccount.filter(
              (i) => i.errorMsg != "" && i.errorMsg != undefined
            ).length;
        })
        .catch((error) => {
          this.handdleError(error);
        });
    },
    checkDocIsSuccess() {
      let document_group_type = this.userData.document_group_type.find(
        (item) => item.grp_id == process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT
      );
      let docCode = document_group_type.lst_doc_id[0];
      let docType = this.userData.documentType.find(
        (v) => v.doc_code == docCode
      );
      return docType.state != undefined && docType.state == "success";
    },
    patternAccount(value) {
      return (
        "***" +
        " " +
        "*" +
        " " +
        "**" +
        value.substring(6, 9) +
        " " +
        value.substring(9, 10)
      );
    },
    goback() {
      this.$router.push({
        name: this.userData.routerPath.documentGroup,
        params: { grpId: process.env.VUE_APP_DOCUMENT_GROUP_STATEMENT },
      });
    },
    handdleError(error) {
      console.error("Handle error case:", error);
      if (error.response) {
        if (
          error.response.data != undefined &&
          error.response.data.code != undefined
        ) {
          this.getAlert(error.response.data.code);
        } else {
          this.getAlert(error.response.status);
        }
      } else if (
        error.message !== undefined &&
        error.message.startsWith("timeout")
      ) {
        this.getAlert("5008");
      } else {
        this.getAlert("9999");
      }
    },
    getAlert(code) {
      let title = null;
      let detail = null;
      switch (code) {
        case "2001":
          (title = "จำนวนเอกสารไม่ครบเงื่อนไขในการสมัคร"),
            (detail = "กรุณาตรวจสอบเอกสารประกอบการสมัครอีกครั้ง");
          break;
        case "4001":
          title = "ท่านทำรายการไม่ถูกต้อง";
          detail = "กรุณาทำรายการใหม่อีกครั้ง";
          break;
        case "4005":
          title = "หมดเวลาทำรายการ";
          detail = "กรุณาลองใหม่อีกครั้ง";
          break;
        case "4006":
          title = "หมดเวลาทำรายการ";
          detail = "กรุณาลองใหม่อีกครั้ง";
          break;
        case "4007":
          title = "ใบสมัครถูกยกเลิก";
          detail =
            "เนื่องจากคุณทำรายการเกินเวลาที่กำหนด คุณสามารถสมัครสินเชื่อได้อีกครั้งผ่านแอปฯ เป๋าตัง หรือ Krungthai NEXT ขอขอบคุณในความไว้วางใจ และหวังเป็นอย่างยิ่งว่าจะได้ให้บริการคุณในโอกาสต่อไป";
          break;
        case "4009":
          title = "หมดเวลาทำรายการ";
          detail = "กรุณาลองใหม่อีกครั้ง";
          break;
        default:
          title = "ไม่สามารถทำรายการได้ในขณะนี้";
          detail = "กรุณาลองใหม่อีกครั้งในภายหลัง";
      }

      this.showAlertThenGotoStatusPages(
        this.imgSwalErr,
        title,
        detail,
        "อัปโหลดเอกสาร"
      );
    },
    showAlertThenGotoStatusPages(img, title, msg, headerTxt) {
      if (this.$swal.isVisible()) return;
      this.$swal
        .fire({
          iconHtml: headerTxt,
          imageUrl: img,
          position: "center",
          title: title,
          text: msg,
          confirmButtonText: "ตกลง",
          confirmButtonColor: "#00A3E4",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          customClass: {
            title:
              "font-kanit-bold-24 text-kanit-color-black dstatement-popup swal2-title-custom",
            confirmButton: "btn btn-block btn-submit-landing-page",
            popup: "swal2-modal-dstatement swal2-modal-next-fullscreen",
            image: "swal2-image-dstatement swal2-image-next-fullscreen",
            htmlContainer:
              "swal2-htmlContainer-next-fullscreen font-kanit-regular-16-16-grey",
            actions: "swal2-actions-next-fullscreen",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            try {
              this.$callback.openLfmStatusPage();
            } catch (err) {
              console.error(err);
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.paleGrey {
  background: #f8f8f8 !important;
  border-radius: 12px;
  border: 0px solid #f8f8f8 !important;
}

.cantClick {
  cursor: not-allowed;
}

.card-active {
  background: #ffffff;

  border: 1px solid #3043cd;
  box-shadow: 0px 0px 0px 2px rgba(68, 87, 227, 0.2);
  border-radius: 8px;
}

.badge-ktb-info {
  box-sizing: border-box;
  position: absolute;
  margin: -10px -10px;
  margin-top: 0rem;
  color: rgb(0, 166, 230) !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.badge-primary {
  border: 2px solid rgb(0, 166, 230);
  box-sizing: border-box;
  position: absolute;
  margin: -10px 0px;
  margin-top: 2px;
  color: rgb(0, 166, 230) !important;
  background-color: transparent;
  width: 24px;
  height: 24px;
}

.card-enabled {
  border: 0.5px solid rgba(151, 151, 151, 0.5) !important;
}

.card-disabled {
  border: 0px !important;
  background: #f2f2f2 !important;
}

.custom-control-label::before {
  width: 24px !important;
  height: 24px !important;
}

.custom-control-label::after {
  width: 24px !important;
  height: 24px !important;
}

.btn-cancel-dstatement {
  color: rgb(219, 0, 0) !important;
  border-color: rgb(219, 0, 0) !important;
  background-color: white !important;
  background-image: unset !important;
}

.content-nowrap {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-left: unset;
}

.swal2-htmlContainer-next-fullscreen {
  font-size: 16px !important;
  margin-bottom: 40vh !important;
  margin-top: 1rem !important;
  line-height: 24px !important;
  height: 50% !important;
}

.swal2-image-next-fullscreen {
  margin-top: 0vh !important;
  margin-bottom: 0vh !important;
}

.swal2-icon {
  border-color: unset !important;
  border: unset !important;
  line-height: 20px !important;
  width: 100% !important;
  margin: 0px !important;
  align-items: unset !important;
}

.swal2-icon-content {
  margin: 0;
  font-family: Kanit-Bold;
  font-size: 20px !important;
  line-height: 24px !important;
  color: #212121 !important;
}

.swal2-modal-next-fullscreen {
  border-radius: 0px !important;
  width: 100% !important;
  padding: 24px !important;
  height: 100vh !important;
  -webkit-animation: unset !important;
  animation: unset !important;
}

.swal2-actions-next-fullscreen {
  display: flex !important;
  justify-content: center !important;
  margin-top: 1rem !important;
  margin-right: 0px !important;
  margin-bottom: 35px !important;
  margin-left: 0px !important;
}
</style>
<style scoped>
.swal2-html-container {
  margin: 1em 1.6em 40vh !important;
}
</style>
